var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[(!_vm.isHiddenRoute)?_c('heads'):_vm._e(),_c('router-view'),(!_vm.isHiddenRoute)?_c('foots',{class:_vm.globalDataArray.siteInfo.greyOut == 1 ? 'bigEventGray' : ''}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }